export interface DonutSegment {
  label: string;
  value: number;
  color: string;
}

interface DonutChartProps {
  segments: DonutSegment[];
  centerLabel: string;
  centerValue: string;
}

export default function DonutChart({ segments, centerLabel, centerValue }: DonutChartProps) {
  const total = segments.reduce((sum, s) => sum + s.value, 0);
  const visible = segments.filter((s) => s.value > 0);

  let acc = 0;
  const parts = visible.map((s) => {
    const start = (acc / total) * 360;
    acc += s.value;
    const end = (acc / total) * 360;
    return `${s.color} ${start.toFixed(1)}deg ${end.toFixed(1)}deg`;
  });

  const gradient =
    parts.length > 0 ? `conic-gradient(${parts.join(", ")})` : "conic-gradient(#E5E7EB 0deg 360deg)";

  return (
    <div className="flex flex-col items-center">
      <div
        className="relative w-28 h-28 sm:w-36 sm:h-36 md:w-44 md:h-44 rounded-full"
        style={{ background: gradient }}
      >
        <div className="absolute inset-[12px] sm:inset-[15px] md:inset-[18px] rounded-full bg-background-50 flex flex-col items-center justify-center">
          <span className="text-base sm:text-xl md:text-2xl font-bold text-foreground-900" dir="ltr">
            {centerValue}
          </span>
          <span className="text-[10px] sm:text-xs text-foreground-400 mt-0.5">{centerLabel}</span>
        </div>
      </div>

      <div className="mt-4 sm:mt-5 w-full space-y-1.5 sm:space-y-2">
        {visible.map((s) => {
          const pct = total ? Math.round((s.value / total) * 100) : 0;
          return (
            <div key={s.label} className="flex items-center gap-2 text-xs sm:text-sm">
              <span className="w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full shrink-0" style={{ backgroundColor: s.color }}></span>
              <span className="flex-1 text-foreground-600 truncate">{s.label}</span>
              <span className="text-foreground-900 font-semibold" dir="ltr">
                {s.value}
              </span>
              <span className="text-foreground-400 text-[11px] sm:text-xs w-8 sm:w-9 text-left shrink-0" dir="ltr">
                {pct}%
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}